module.exports = {
  lowercase: require('./lowercase'),
  uppercase: require('./uppercase'),
  numbers: require('./numbers'),
  nolookalikes: require('./nolookalikes'),
  nolookalikesSafe: require('./nolookalikes-safe'),
  alphanumeric: require('./alphanumeric'),
}
